import React, { useState, useEffect } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import dayjs from 'dayjs'
import { StyledDropdownToggle } from '../../StandardDropdown/StandardDropdown.styles'
import { PlaceholderText } from '../Inputs.styles'
import {
  PrimaryButton,
  SecondaryButton,
  StandardButtonSize,
} from '../../Buttons'
import { FlexColumn, FlexRow, FlexAlign } from '../../Flex'
import { CalendarProxy } from './DatePicker.styles'

export interface DatePickerProps {
  placeholder?: string
  onChange?: (date: Date) => void
  initialDate?: Date
  isDisabled?: boolean
}

export const DatePicker = ({
  placeholder,
  onChange,
  initialDate,
  isDisabled,
}: DatePickerProps): JSX.Element => {
  const [date, setDate] = useState(new Date())
  const [stagedDate, setStagedDate] = useState(new Date())
  const [showDropdown, setShowDropdown] = useState(false)

  useEffect(() => {
    const newDate = initialDate || new Date()
    setDate(newDate)
    setStagedDate(newDate)
  }, [initialDate])

  useEffect(() => {
    if (showDropdown) {
      setStagedDate(date)
    }
  }, [showDropdown, date])

  const handleCalendarChange = (newDate: Date) => {
    setStagedDate(newDate)
  }

  const handleSave = () => {
    setDate(stagedDate)
    onChange?.(stagedDate)
    setShowDropdown(false)
  }

  const handleCancel = () => {
    setStagedDate(date)
    setShowDropdown(false)
  }

  return (
    <Dropdown
      style={{ width: '100%' }}
      show={showDropdown}
      onToggle={(nextShow) => setShowDropdown(nextShow)}
    >
      <Dropdown.Toggle
        as={StyledDropdownToggle}
        style={{
          height: '40px',
          width: '100%',
        }}
        disabled={isDisabled}
      >
        {date ? (
          dayjs(date).format('YYYY-MM-DD hh:mm A')
        ) : (
          <PlaceholderText>{placeholder || 'Select Date'}</PlaceholderText>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <FlexColumn isFullHeight isFullWidth>
          <CalendarProxy
            color="black"
            date={stagedDate}
            minDate={new Date()}
            onChange={handleCalendarChange}
          />
          <FlexRow
            justify={FlexAlign.FLEX_END}
            align={FlexAlign.CENTER}
            gap={8}
            isFullWidth
            $padding={8}
          >
            <SecondaryButton
              size={StandardButtonSize.SMALL}
              onClick={handleCancel}
              text="Cancel"
            />
            <PrimaryButton
              size={StandardButtonSize.SMALL}
              onClick={handleSave}
              text="Save"
            />
          </FlexRow>
        </FlexColumn>
      </Dropdown.Menu>
    </Dropdown>
  )
}
